import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import app from "./modules/app";
import session from "./modules/session";
import account from "./modules/account";
import billing from "./modules/billing";
import user from "./modules/user";
import role from "./modules/role";
import tenant from "./modules/tenant";
import goal from "./modules/goal";
import review from "./modules/review";
import project from "./modules/project";
import team from "./modules/team";

const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    billing,
    user,
    role,
    tenant,
    goal,
    review,
    project,
    team
  }
});

export default store;
